var map = {
	"./ActionsModal/Cambio.vue": 811,
	"./ActionsModal/SaveChanges.vue": 812,
	"./ActionsModal/index.vue": 248,
	"./agrocolor.vue": 2083,
	"./araporcei.vue": 2084,
	"./coplaca/ParcelasActionsMultiple.vue": 1141,
	"./coplaca/index.vue": 2085,
	"./default.vue": 2086,
	"./demo.vue": 2087,
	"./sites.vue": 309,
	"./widgets/auditorias.vue": 813,
	"./widgets/dictamenes.vue": 816,
	"./widgets/pacs.vue": 818,
	"./widgets/revisiones.vue": 815,
	"./widgets/solicitudes.vue": 814,
	"./widgets/toma_muestras.vue": 817
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1794;